import React, { Component } from "react";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import axios from "axios";
const BaseURL = "https://backend-197598313260.asia-south1.run.app";
// const BaseURL = "http://localhost:4000";

class WHReturnItemsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returnItems: [],
      originalRows: [],
      searchTerm: "",
      statusFilter: "all",
      storeID: this.props.match.params.storeID,
      loading: false,
      transactionDetails: null,
    };
  }

  componentDidMount() {
    this.fetchReturnItems();
  }

  groupByGID(rows) {
    const grouped = {};

    rows.forEach((item) => {
      if (!grouped[item.GID]) {
        grouped[item.GID] = {
          GID: item.GID,
          ProductName: item.ProductName,
          Barcode: item.Barcode,
          TotalQty: 0,
          StatusList: [],
          items: [],
          showDetails: false,
        };
      }

      grouped[item.GID].TotalQty += item.Qty;
      grouped[item.GID].StatusList.push(item.Status);
      grouped[item.GID].items.push(item);
    });

    return Object.values(grouped);
  }

  fetchReturnItems = async () => {
    this.setState({ loading: true });

    try {
      const res = await axios.get(
        `${BaseURL}/v1/vendorstockinward/whreturnitems`,
        {
          params: { StoreID: this.state.storeID },
        }
      );

      const rows = res.data.data || [];
      const grouped = this.groupByGID(rows);

      this.setState({
        originalRows: rows,
        returnItems: grouped,
        loading: false,
        transactionDetails: res.data.transactionInfo || null,
      });
    } catch (err) {
      console.error("Error fetching WHReturnItems:", err);
      this.setState({ loading: false });
    }
  };

  toggleDetails = (index) => {
    const list = [...this.state.returnItems];
    list[index].showDetails = !list[index].showDetails;
    this.setState({ returnItems: list });
  };

  handlePrint = () => {
    window.print();
  };

  getStatus(item) {
    if (item.StatusList.every((s) => s === "Ready To Return"))
      return "Ready To Return";
    if (item.StatusList.every((s) => s === "Pending")) return "Pending";
    return "Mixed";
  }

  filterItems() {
    let list = [...this.state.returnItems];

    if (this.state.statusFilter !== "all") {
      list = list.filter((item) =>
        this.state.statusFilter === "ready"
          ? item.StatusList.includes("Ready To Return")
          : item.StatusList.includes("Pending")
      );
    }

    if (this.state.searchTerm) {
      const text = this.state.searchTerm.toLowerCase();
      list = list.filter(
        (item) =>
          item.ProductName.toLowerCase().includes(text) ||
          item.GID.toLowerCase().includes(text)
      );
    }

    return list;
  }

  // ⭐⭐⭐ READY TO RETURN API ⭐⭐⭐
  handleReadyToReturn = async () => {
    try {
      this.setState({ loading: true });
      const storeID = this.state.storeID;

      const res = await axios.put(
        `${BaseURL}/v1/vendorstockinward/whreturn/${storeID}`,
        { Status: "Ready To Return" }
      );

      alert("Status Updated Successfully!");
      this.fetchReturnItems();
    } catch (err) {
      console.error("Error updating status:", err);
      alert("Failed to update status");
    } finally {
      this.setState({ loading: false });
    }
  };

  // PRINT TABLE
  renderPrintTable() {
    return (
      <div>
        <h3 style={{ marginBottom: 10 }}>WH Return Items</h3>

        <table className="table table-bordered" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Sr</th>
              <th>Product</th>
              <th>Transaction Type</th>
              <th>Total Qty</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>

          <tbody>
            {this.state.returnItems.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>{index + 1}</td>

                  <td>
                    <b>{item.ProductName}</b> <br />
                    GID: {item.GID} <br />
                    Barcode: {item.Barcode}
                  </td>

                  <td>
                    {item.items && item.items[0] && item.items[0].TransactionType
                      ? item.items[0].TransactionType
                      : "N/A"}
                  </td>


                  <td>{item.TotalQty}</td>
                  {/* <td>{this.getStatus(item)}</td> */}
                </tr>

                {item.items.map((sub, idx) => (
                  <tr key={idx} style={{ background: "#f2f2f2" }}>
                    <td></td>
                    <td colSpan="1">{sub.TransactionNo}</td>
                    <td>
                      {new Date(sub.TransactionDate).toLocaleDateString()}
                    </td>
                    <td>{sub.Qty}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderTable() {
    const filtered = this.filterItems();

    return (
      <div className="no-print">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Product (Name + GID + Barcode)</th>
              <th>Transaction  Type</th>
              <th>Total Qty</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>

          <tbody>
            {filtered.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>{index + 1}</td>

                  <td>
                    <b>{item.ProductName}</b> <br />
                    GID: {item.GID} <br />
                    Barcode: {item.Barcode} <br />

                    <a
                      href="#!"
                      onClick={() => this.toggleDetails(index)}
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        fontSize: "13px",
                      }}
                    >
                      {item.showDetails ? "Hide" : "Break-up"}
                    </a>

                    {item.showDetails && (
                      <div style={{ marginTop: 10 }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>TransactionNo</th>
                              <th>TransactionDate</th>
                              <th>Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.items.map((sub, idx) => (
                              <tr key={idx}>
                                <td>{sub.TransactionNo}</td>
                                <td>
                                  {new Date(
                                    sub.TransactionDate
                                  ).toLocaleDateString()}
                                </td>
                                <td>{sub.Qty}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </td>

                 <td>
  {item.items && item.items[0] && item.items[0].TransactionType
    ? item.items[0].TransactionType
    : "N/A"}
</td>


                  <td>{item.TotalQty}</td>
                  {/* <td>{this.getStatus(item)}</td> */}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderTransactionDetails() {
    const t = this.state.transactionDetails;
    if (!t) return null;

    return (
      <div
        style={{
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderRadius: "5px",
          marginBottom: "20px",
        }}
      >
        <h4>Return Transaction Info</h4>

        <div>
          <b>ReturnTransactionNo:</b> {t.ReturnTransactionNo}
        </div>
        <div>
          <b>ReturnTransactionDate:</b>{" "}
          {new Date(t.ReturnTransactionDate).toLocaleString()}
        </div>
        <div>
          <b>PickupDate:</b> {new Date(t.PickupDate).toLocaleString()}
        </div>
        <div>
          <b>Store Name:</b> {t.StoreName}
        </div>
        <div>
          <b>Total Qty:</b> {t.TotalQty}
        </div>
        <div>
          <b>Status:</b> {t.Status}
        </div>
      </div>
    );
  }

  // ⭐⭐⭐ FOOTER ⭐⭐⭐
  renderFooter() {
     const t = this.state.transactionDetails;
    return (
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderTop: "1px solid #dee2e6",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0 auto",
          }}
        >
          <div style={{ flex: 1 }}></div>

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              className="btn btn-flat btn-default"
              onClick={() => this.props.history.goBack()}
            >
              <i className="fa fa-arrow-left mr-2"></i> Back
            </button>

        {t&&t.Status!=="Ready To Return" &&<button
              type="button"
              className="btn btn-success"
              onClick={this.handleReadyToReturn}
            >
              Ready To Return
            </button>}
              {/* PRINT BUTTON */}
      
            <button
              className="btn btn-success"
              onClick={this.handlePrint}
            >
              🖨️ Print
            </button>
       
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Page hideHeader={true}>
        <PageSection>
   
    

          {this.renderTransactionDetails()}
          {this.renderTable()}

          <div className="print-only">{this.renderPrintTable()}</div>
        </PageSection>

        {/* FOOTER OUTSIDE PAGESECTION */}
        {this.renderFooter()}

        <style>{`
          @media print {
            .no-print { display: none !important; }
            .print-only { display: block !important; }
          }
          @media screen {
            .print-only { display: none; }
          }
        `}</style>
      </Page>
    );
  }
}

export default WHReturnItemsView;
